import { post } from './base/index';

export default {
    sendQuery: (data,headers)=>{
        // debugger
        return post(`${window.apiUrl}ContactUs/send-query`,data,headers)
    }
}